/**
 * Calcula el valor promedio de Swolf para una sesión de natación.
 * Swolf = (tiempo por longitud) + (brazadas por longitud)
 *
 * @param {Array} laps - Arreglo de vueltas con datos de natación
 * @returns {number|null} - Swolf promedio o null si no es válido
 */
const calculateSwolf = (laps = []) => {
  if (!Array.isArray(laps) || laps.length === 0) return null;

  const validLaps = laps.filter(lap =>
    lap.num_active_lengths > 0 &&
    lap.total_timer_time > 0 &&
    lap.total_cycles > 0
  );

  if (validLaps.length === 0) return null;

  const totalSwolf = validLaps.reduce((sum, lap) => {
    const lengths = lap.num_active_lengths;
    const time = lap.total_timer_time;
    const strokes = lap.total_cycles;

    const swolfValue = time / lengths + strokes / lengths;
    return sum + swolfValue;
  }, 0);

  const averageSwolf = totalSwolf / validLaps.length;

  console.log('✅ Swolf promedio calculado:', averageSwolf);

  return isFinite(averageSwolf) && averageSwolf > 0
    ? parseFloat(averageSwolf.toFixed(1))
    : null;
};

/**
 * Calcula el valor de Swolf para una vuelta individual
 *
 * @param {Object} lap - Objeto de vuelta individual
 * @returns {number|null} - Swolf de la vuelta o null si no es válido
 */
const calculateLapSwolf = (lap) => {
  if (!lap || !lap.num_active_lengths) return null;

  const lengths = lap.num_active_lengths;
  const time = lap.total_timer_time || 0;
  const strokes = lap.total_cycles || 0;

  const swolfValue = time / lengths + strokes / lengths;

  return isFinite(swolfValue) && swolfValue > 0
    ? parseFloat(swolfValue.toFixed(1))
    : null;
};

module.exports = { calculateSwolf, calculateLapSwolf };
